import type { FC, ReactNode } from 'react';

import dynamic from 'next/dynamic';
import { memo } from 'react';

import { S } from '../styles';
import { useTileRenderLowestPrice } from '~/components/shared/recommendations/tile/hooks/useTileRenderLowestPrice';
import { ProductDataInfo } from '~/components/shared/recommendations/tile/productData/ProductDataInfo';
import { TilePriceLowest30Days } from '~/components/shared/recommendations/tile/TilePriceLowest30Days';

const ProductDataVariants = dynamic(
  async () => (await import('./ProductDataVariants')).ProductDataVariants,
  { ssr: false }
);

type ProductDataHoverCardProps = {
  productInfo?: ReactNode;
};

/**
 * Desktop hover state of the tile: name and price of the hovered variant followed by the swatches.
 * Rendered outside the tile link (swatches are buttons) and laid over the product info,
 * so the text part lets clicks fall through to the link underneath.
 */
const ProductDataHoverCardComponent: FC<ProductDataHoverCardProps> = ({ productInfo }) => {
  const renderLowestPrice = useTileRenderLowestPrice();

  return (
    <S.HoverCard data-testid="product-tile-hover-card">
      <S.HoverCardInfo aria-hidden="true">
        <ProductDataInfo renderLowestPrice={renderLowestPrice}>{productInfo}</ProductDataInfo>
        {renderLowestPrice && <TilePriceLowest30Days flexible />}
      </S.HoverCardInfo>

      <S.HoverCardVariants>
        <ProductDataVariants />
      </S.HoverCardVariants>
    </S.HoverCard>
  );
};

export const ProductDataHoverCard = memo(ProductDataHoverCardComponent);
